import { i18n } from '~/utils';

/*
 * Possible values for delivery type, aka INCOTERMS.
 */
export const DELIVERY_TYPE = {
  CFR: i18n.t(($) => $.deliveryNote.deliveryType.CFR),
  CIF: i18n.t(($) => $.deliveryNote.deliveryType.CIF),
  CIP: i18n.t(($) => $.deliveryNote.deliveryType.CIP),
  CPT: i18n.t(($) => $.deliveryNote.deliveryType.CPT),
  DAP: i18n.t(($) => $.deliveryNote.deliveryType.DAP),
  DDP: i18n.t(($) => $.deliveryNote.deliveryType.DDP),
  DPU: i18n.t(($) => $.deliveryNote.deliveryType.DPU),
  EXW: i18n.t(($) => $.deliveryNote.deliveryType.EXW),
  FAS: i18n.t(($) => $.deliveryNote.deliveryType.FAS),
  FCA: i18n.t(($) => $.deliveryNote.deliveryType.FCA),
  FH: i18n.t(($) => $.deliveryNote.deliveryType.FH),
  FOB: i18n.t(($) => $.deliveryNote.deliveryType.FOB),
} as const;

export type DeliveryTypeType = keyof typeof DELIVERY_TYPE;

export const CARGO_TYPE_I18N_MAP = () =>
  ({
    concrete: i18n.t(($) => $.deliveryNote.cargoType.concrete, {
      ns: 'deliveryNotes',
    }),
    piece: i18n.t(($) => $.deliveryNote.cargoType.piece, {
      ns: 'deliveryNotes',
    }),
    bulk: i18n.t(($) => $.deliveryNote.cargoType.bulk, { ns: 'deliveryNotes' }),
  }) as const;

export type CargoType = keyof ReturnType<typeof CARGO_TYPE_I18N_MAP>;

/**
 * A map of shipping mark codes and their corresponding i18n keys.
 */
export const SHIPPING_MARK_CODES_I18N_MAP = () => ({
  COL: i18n.t(($) => $.shippingMark.type.colliNumber, { ns: 'deliveryNotes' }),
  39: i18n.t(($) => $.shippingMark.type.nveNumber, { ns: 'deliveryNotes' }),
  generic: i18n.t(($) => $.shippingMark.type.generic, { ns: 'deliveryNotes' }),
});
